var magicStyles = [" [data-v-8e7295bc-host],:host{display:contents}.list[data-v-8e7295bc]{display:flex;flex-wrap:wrap;margin:0 0 var(--magic-space,16px);width:100%}"];

export default magicStyles;
